export default {
  title: {
    'zh-cn': '蜂巢智能管控平台',
    'zh-tw': '蜂巢智能管控平台',
    'en': 'Honeycomb Smart'
  },
  username: {
    'zh-cn': '用户名',
    'zh-tw': '用戶名',
    'en': 'Username'
  },
  password: {
    'zh-cn': '密码',
    'zh-tw': '密碼',
    'en': 'Password'
  },
  usernamePlaceholder: {
    'zh-cn': '请输入用户名',
    'zh-tw': '請輸入用戶名',
    'en': 'Please enter username'
  },
  passwordPlaceholder: {
    'zh-cn': '请输入密码',
    'zh-tw': '請輸入密碼',
    'en': 'Please enter password'
  },
  rememberPassword: {
    'zh-cn': '记住密码',
    'zh-tw': '記住密碼',
    'en': 'Remember password'
  },
  submit: {
    'zh-cn': '提交',
    'zh-tw': '提交',
    'en': 'Submit'
  },
  version: {
    'zh-cn': '版本：',
    'zh-tw': '版本：',
    'en': 'Version: '
  },
  copyright: {
    'zh-cn': 'CopyRight © 深圳信路通智能技术有限公司 版权所有',
    'zh-tw': 'CopyRight © 深圳信路通智能技術有限公司 版權所有',
    'en': 'CopyRight © Shenzhen Signaltone Technologies Co., LTD. (Signaltone) All rights reserved'
  },
  validation: {
    usernameRequired: {
      'zh-cn': '请输入账号',
      'zh-tw': '請輸入賬號',
      'en': 'Please enter account'
    },
    usernameMustNumber: {
      'zh-cn': '请输入数字',
      'zh-tw': '請輸入數字',
      'en': 'Please enter a number'
    },
    usernameMaxLength: {
      'zh-cn': '账号最大长度32个字符',
      'zh-tw': '賬號最大長度32個字符',
      'en': 'Account maximum length is 32 characters'
    },
    passwordRequired: {
      'zh-cn': '请输入密码',
      'zh-tw': '請輸入密碼',
      'en': 'Please enter password'
    },
    passwordMinLength: {
      'zh-cn': '密码最小长度6个字符',
      'zh-tw': '密碼最小長度6個字符',
      'en': 'Password minimum length is 6 characters'
    },
    passwordMaxLength: {
      'zh-cn': '密码最大长度32个字符',
      'zh-tw': '密碼最大長度32個字符',
      'en': 'Password maximum length is 32 characters'
    }
  },
  agreement: {
    text: {
      'zh-cn': '我已阅读同意',
      'zh-tw': '我已閱讀同意',
      'en': 'I have read and agree to the'
    },
    dialogTitle: {
      'zh-cn': '提示',
      'zh-tw': '提示',
      'en': 'Notice'
    },
    dialogMessage: {
      'zh-cn': '进入下一步前，请先阅读并同意',
      'zh-tw': '進入下一步前，請先閱讀並同意',
      'en': 'Before proceeding, please read and agree to the'
    },
    confirmButton: {
      'zh-cn': '同意并继续',
      'zh-tw': '同意並繼續',
      'en': 'Agree and Continue'
    }
  }
}

